<!-- <section class="vh-100" style="background-color: #385b9b;">
  <div class="container py-5 h-100">
    <div class="row MainDiv h-100"> -->
      <!-- Login Pannel Size According To Resolution -->
      <!-- <div class="col-sm col-md-10 col-lg-9 col-xl-7 animationLogin">
        <div class="card" style="border-radius: 1rem;">
          <div class="row g-0"> -->
            <!-- Login Pannel Img -->
            <!-- <div class="col-sm col-md col-lg col-xl d-none d-md-block">
              <img src="../../../assets/Images/loginpage.webp" alt="login form" class="img-fluid ColImg"/>
            </div> -->
            <!-- Login Pannel -->
            <!-- <div class="col-sm col-md col-lg col-xl LoginPannel" *ngIf="!isLoggedIn"> -->
              <!-- Padding Spacing In Logout PANNEL -->
              <!-- <div class="card-body p-2 p-md-3 p-lg-4 p-xl-5">
                <form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="loginProcess()"> -->
                  <!-- Meril Logo -->
                  <!-- <span>
                    <img src="../../../assets/Images/meril-logo.png" style="width: 30%;" class="LoginMerilLogo">
                  </span> -->
                  <!-- Welcome -->
                  <!-- <h2 class="LoginH2"><b>Welcome</b></h2> -->
                  <!-- Login -->
                  <!-- <h5 class="LoginH5"><b>Log In</b></h5> -->
                  <!-- Username -->
                  <!-- <div class="mb-2">
                    <input type="text" class="form-control input-field" name="userName" id="userName" formControlName="username" placeholder="Enter UserName" autofocus tabindex="1">
                  </div> -->
                  <!-- Password -->
                  <!-- <div class="mb-1">
                    <input [type]="type" class="form-control input-field" name="password" id="password" formControlName="password" placeholder="Password" tabindex="1">
                  </div> -->
                  <!-- Forgot Password -->
                  <!-- <div class="text-end">
                    <p><a href="#" class="LoginPTag" [routerLinkActive]="['router-link-active']" [routerLink]="['/forgotPassword']" [ariaDisabled]="loading">Have trouble logging in?</a></p> 
                  </div> -->
                  <!-- Captcha -->
                  <!-- <app-captcha [config]="captchaConfig" formControlName="captchaData"/> -->
                  <!-- <app-captcha [config]="captchaConfig" (captchaCode)="onCaptchaResult($event)"/> -->
                  <!-- Buttons -->
                  <!-- <div class="row mt-3">
                    <div class="col">
                      <button type="submit" class="btn btn-outline-success form-control" tabindex="1" [disabled]="loading"><b>Submit<span class="spinner-border spinner-border-sm" *ngIf="loading" role="status" aria-hidden="true"></span></b></button>
                    </div>
                    <div class="col">
                      <button type="reset" class="btn btn-outline-danger form-control" [disabled]="loading"><b>Reset</b></button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="col-sm col-md col-lg col-xl LoginPannel animationSubjectAndRole" *ngIf="isLoggedIn" > -->
              <!-- *ngIf="!isLoggedIn" -->
              <!-- <div class="card-body p-2 p-md-3 p-lg-4 p-xl-5">
                <app-roles-and-study></app-roles-and-study>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mt-2">
          <p class="cardFooter" style="color: white;">{{copyRight}}<span> {{appVersion}}</span></p>
        </div>
      </div>
    </div>
  </div>
</section>   -->

<!-- /* Try New LoginPage CSS */ -->
<section class="back-image">
  <div class="container">
    <div class="row mainDiv py-5">
      <div class="col-sm col-md-10 col-lg-9 col-xl-7 animationForContainer">
        <div class="card">
          <div class="row g-0">
            <div class="col-sm col-md col-lg col-xl d-none d-md-block">
              <img src="../../../assets/Images/login_image.jpg" alt="login form" class="img-fluid colImg"/>
            </div>
            @if (!isLoggedIn) {
              <div class="col-sm col-md col-lg col-xl loginPannel  animationForRightSection">
                <div class="card-body p-4 p-md-3 main-section-login">
                  @if (formGroup) {
                    <form class="d-flex flex-column h-100" [formGroup]="formGroup" (ngSubmit)="loginProcess()">
                      <!-- Meril Logo -->
                      <!-- <span>
                        <img src="../../../assets/Images/meril-logo.png" style="width: 30%;" class="LoginMerilLogo">
                      </span> -->
                      <h6 class="loginH2">Welcome</h6>
                      <hr class="mt-0 hr-loginpage" />
                      <h4 class="loginH5">{{loginText}}</h4>
                      <div class="mb-2">
                        <label class="form-label login-label">Username<span class="text-danger">*</span></label>
                        <input type="text" class="form-control input-field border-2" data-testid = "username" name="userName" id="userName" formControlName="username" placeholder="Username" autofocus tabindex="1" maxlength="50" (input)="onUserNameChange($event)">
                        @if (usernameError) {
                          <div class="text-danger small mt-1">
                            {{usernameError}}
                          </div>
                        }
                      </div>
                      <div class="mb-1">
                        <label class="form-label login-label">Password<span class="text-danger">*</span></label>
                        <input [type]="type" class="form-control input-field border-2" data-testid ="password" name="password" id="password" formControlName="password" placeholder="**********" tabindex="1" (input)="onResetErrors(false)">
                        <div  class="text-danger small mt-1">
                          @if (passwordError) {
                              {{passwordError}}
                            } @else if(loginError) {
                                {{loginError}}
                            }
                        </div>
                      </div>
                      <div class="text-end">
                        <p><a href="#" class="loginPTag login-label" data-testid = "link-forgot-password"[routerLinkActive]="['router-link-active']" [routerLink]="['/forgotPassword']" [ariaDisabled]="loading" [class.disabled-link]="loading">Forgot Password?</a></p> 
                      </div>
                       @if(environment !== DEV_PROFILE) {
                         <app-captcha [config]="captchaConfig" (captchaCode)="onCaptchaResult($event)" [isLoad]="loading"/>
                      }
                      <div class="sticky-bottom-buttons bottom-buttons-div">
                        <div class="row mt-3 bottom-buttons">
                          <div class="col">
                            <button type="reset" class="btn btn-cancel form-control mb-4" [disabled]="loading" (click)="onResetErrors(true)">Reset</button>
                          </div>
                          <div class="col">
                            <button type="submit" class="btn btn-submit form-control mb-4" data-testid="btn-login" tabindex="1" [disabled]="loading">{{loginText}} 
                              <!-- @if (loading) {
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              } -->
                            </button>
                          </div>
                         
                        </div>
                      </div>
                    </form>
                  }
                </div>
              </div>
            } @else {
              <div class="col-sm col-md col-lg col-xl loginPannel animationForRightSection">
                <div class="card-body p-4 p-md-3 main-section-login">
                  <app-roles-and-study></app-roles-and-study>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="text-center mt-2">
          <p class="cardFooter copyright-text" >
            {{copyRight}}
          </p>
        </div>
      </div>
    </div>
  </div>
</section>  